<!-- ngIf: section.title -->
<h4 data-ng-if="section.title" class="section-title list-digit list-digit__target grid-9 grid-mobile-4 ng-scope">
    <span class="section-title__title ng-binding">
        {{ questionQuestionnaireSante.libelle ? questionQuestionnaireSante.libelle : ('medicalworkflow.questionTitle_6' | i18n) }}
    </span>
</h4>
<!-- end ngIf: section.title -->
<ol class="simulation__list grid-12 grid-mobile-4 no-gutter">
    <!-- ngRepeat: question in section.questions track by $index -->
    <li
        *ngFor="let sousQuestion of sousQuestions"
        data-ng-repeat="question in section.questions track by $index"
        class="simulation__listItem simulation__listItem--qs-summary question grid-container ng-scope"
        data-ng-class="{
              'list-digit--alpha': !question.topQuestion &amp;&amp; section.questions.length > 1 &amp;&amp; (section.title || !$first),
              'list-digit': question.topQuestion || (section.questions.length>1 &amp;&amp; !section.title &amp;&amp; $first),
              'height-weight-question': question.heightWeight,
              'not-height-weight-question': !question.heightWeight
            }"
    >
        <div data-question-medical-workflow="" data-question="question" class="grid-container ng-isolate-scope list-digit--sub">
            <div>
                <app-question-motif-component [qsForm]="qsForm" [questionQuestionnaireSante]="sousQuestion"> </app-question-motif-component>
            </div>
        </div>
    </li>
    <!-- end ngRepeat: question in section.questions track by $index -->
</ol>
